export default function customImageLoader({ src, width, quality }) {
  /**
   * Cloudflare CDN images are optimized according to the width and quality.
   * we need to pass these parameters to the Cloudflare Transform API to get responsive images.
   */
  if (src.startsWith('https://www.nerdwallet.com/cdn') && width !== undefined) {
    const imagePath = src.split('https://www.nerdwallet.com')[1];
    return `https://www.nerdwallet.com/cdn-cgi/image/format=webp,quality=${quality || 80},width=${width}${imagePath}`;
  }

  if (src.startsWith('https://stage.nerdwallet.biz/cdn') && width !== undefined) {
    const imagePath = src.split('https://stage.nerdwallet.biz')[1];
    return `https://stage.nerdwallet.biz/cdn-cgi/image/format=webp,quality=${quality || 80},width=${width}${imagePath}`;
  }

  // Use NextJS image optimization API for relative urls.
  return `/interstitial-client-next-images/_next/image?url=${src}&w=${width}&q=${quality || 75} `;
}

